import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "light" | "dark";

interface ThemeState {
  mode: ThemeMode;
  toggleTheme: () => void;
  setMode: (mode: ThemeMode) => void;
}

/** Mirrors the store onto <html> so the CSS tokens and Tailwind's dark variant follow it. */
export function applyThemeToDocument(mode: ThemeMode) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.dataset.theme = mode;
  root.classList.toggle("dark", mode === "dark");
  root.style.colorScheme = mode;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: "light",
      toggleTheme: () => set((state) => ({ mode: state.mode === "light" ? "dark" : "light" })),
      setMode: (mode) => set({ mode }),
    }),
    {
      name: "taskpart-theme",
      // v2 made the soft light theme the default. Earlier versions stored "dark"
      // only because it was the default then, so start everyone on light once.
      version: 2,
      migrate: () => ({ mode: "light" as ThemeMode }),
    },
  ),
);
